import {Button} from 'antd'
import http from '@/biz/http.mjs'
import runAsync from '@/script/runAsync.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'

const ButtonMap = ({url, ...props}) => {
    const map = useMapContext()

    const onClick = async () => {
        const isVm = n => 'VM' === n.data.bizNodeType

        const next = chain => {
            const [n] = chain
            const yieldNode = isVm(n) && n.data.pkid
            const yieldChildren = yieldNode
            return {yieldChildren, yieldNode}
        }

        const {prjId, sVer} = map.data
        const pkids = []

        for (const n of map.topNodes(map.selectedNodes)) {
            for (const nn of map.dfs(n, next)) {
                pkids.push(nn.data.pkid)
            }
        }

        await runAsync(
            () => http.post(url, {pkids, prjId, sVer}),
            {action: props.children}
        )

        map.refreshMap()
    }

    return (
        <Button
            onClick={onClick}
            {...props}
        />
    )
}

export const PropertiesPaneButtonClearMap = props => {
    return (
        <ButtonMap
            url="/autoIntegrate/batchUninstallVmMap"
            {...props}
        >
            批量卸载程序地图模件
        </ButtonMap>
    )
}

export const PropertiesPaneButtonIntegrateMap = props => {
    return (
        <ButtonMap
            url="/autoIntegrate/batchIntegrateVmMap"
            {...props}
        >
            批量集成程序地图模件
        </ButtonMap>
    )
}
